const config = {
    testEnvironment: 'jsdom',
};

module.exports = config;
